import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Church, BookOpenText, Star, X } from 'lucide-react';

/**
 * About Us modal — extracted from App.js HomePage (Feb 2026 P3 refactor).
 * Static content; fully self-contained.
 */
const AboutUsModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <div
        data-testid="about-us-modal"
        className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      >
        <motion.div
          className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
        >
          <div className="p-6 border-b border-slate-200 bg-gradient-to-r from-blue-50 to-purple-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="p-3 rounded-xl bg-gradient-to-r from-blue-500 to-purple-500">
                  <Church className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-800">About Us</h3>
                  <p className="text-sm text-slate-600">
                    Celestial Church of Christ - Valley of Berachah
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                data-testid="about-us-modal-close"
                className="p-2 rounded-xl hover:bg-slate-100 transition-colors"
              >
                <X className="w-6 h-6 text-slate-600" />
              </button>
            </div>
          </div>

          <div className="overflow-y-auto max-h-[calc(85vh-100px)] p-8">
            <div className="space-y-6">
              <p className="text-lg leading-relaxed text-slate-700">
                The{' '}
                <strong className="text-blue-700">
                  Celestial Church of Christ – Valley of Berachah
                </strong>{' '}
                is a Spirit-led Christian church devoted to worship, holiness, prayer, and the
                teaching of God's Word. We are part of the worldwide Celestial Church of Christ
                founded in 1947 through the divine calling of Samuel Bilewu Joseph Oshoffa.
              </p>

              <p className="text-lg leading-relaxed text-slate-700">
                Rooted in this sacred spiritual heritage, our pastoral leadership is committed to
                guiding believers, nurturing faith, and creating a place of prayer, restoration,
                and blessing for all.
              </p>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-50 to-orange-50 p-6 border-2 border-amber-200 my-6">
                <div className="absolute top-0 right-0 text-8xl text-amber-200/30 font-serif">"</div>
                <div className="relative z-10">
                  <BookOpenText className="w-6 h-6 text-amber-600 mb-3" />
                  <p className="text-xl font-medium text-slate-800 italic mb-3">
                    "So they called that place the Valley of Berachah, for there they blessed the
                    LORD."
                  </p>
                  <p className="text-amber-700 font-bold">— 2 Chronicles 20:26 (KJV)</p>
                </div>
              </div>

              <div className="text-center pt-4">
                <div className="inline-block p-6 rounded-2xl bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200">
                  <Star className="w-10 h-10 text-amber-500 mx-auto mb-3" />
                  <p className="text-xl font-bold text-slate-800 mb-1">
                    You are welcome to worship with us
                  </p>
                  <p className="text-lg text-blue-700">and experience God's presence.</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default AboutUsModal;
